// extracted by mini-css-extract-plugin
export var container = "_3r-0";
export var disabled = "_3r-4";
export var fullWidth = "_3r-3";
export var lined = "_3r-1";
export var selected = "_3r-5";
export var tab = "_3r-2";